module.exports = __webpack_public_path__ + "img/hardware1.f2cc66a6.png";